<template>
  <div
    ref="howItWorksContainer"
    class="how-it-works__container">
    <h2 class="how-it-works__header">
      How it works
    </h2>
    <ul class="steps">
      <li
        v-for="(title, index) in titles"
        :key="title"
        :class="{'active': isVisible || (index === 0 && !endAnimationFlag)}"
        :style="{ '--item-delay': `${index}s` }"
        class="steps__item">
        <div class="steps__number-label" />
        <span class="steps__text-label">
          {{ title }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'HowItWorks',

  props: {
    titles: {
      type: Array,
      default: () => [
        'Choose a service and discuss details',
        'Track your order status in real-time',
        'Get matched with a top PRO player instantly',
        'Enjoy your rewards!',
      ],
    },
  },

  data() {
    return {
      isVisible: false,
      endAnimationFlag: false,
      delayBeforeRemoveClass: 5000,
    };
  },

  mounted() {
    this.setAnimation();
  },

  methods: {
    setAnimation() {
      /*
        Всем блокам, кроме первого, задаем анимационный класс
        при вхождении контейнера в область экрана.
        Через delayBeforeRemoveClass удаляем все классы
       */
      const target = this.$refs.howItWorksContainer;

      const observer = new IntersectionObserver((entries, obser) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible = true;

            setTimeout(() => {
              this.isVisible = false;
              this.endAnimationFlag = true;
              obser.unobserve(entry.target);
            }, this.delayBeforeRemoveClass);
          }
        });
      }, { threshold: 0.9 });

      observer.observe(target);
    },
  },
};
</script>

<style lang="scss" scoped>
  .how-it-works__container {
    --steps-template-columns: 1fr 1fr 1fr 1fr;
  }

  .how-it-works__header {
    font-weight: 500;
    font-size: 21px;
    margin-bottom: 13px;
  }

  .steps {
    font-weight: 500;
    font-size: 13px;
    counter-reset: works-title-list;
  }

  .steps__item {
    position: relative;
    background: $color--additional-gray;
    display: flex;
    align-items: center;
    height: 68px;
    color: $color--basic-light-gray;
    margin-bottom: 5px;
    padding: 0 30px 0 16px;
    transition:
      background var(--transition-color-time) var(--transition-color-easing),
      color var(--transition-color-time) var(--transition-color-easing);

    &:not(:first-child):before {
      content: '';
      border-style: solid;
      border-width: 10px 19px 0 19px;
      border-color: $color--basic-black transparent transparent transparent;
      position: absolute;
      top: 0;
      left: 10px;
    }

    &:after {
      content: '';
      border-style: solid;
      border-width: 10px 19px 0 19px;
      border-color: $color--additional-gray transparent transparent transparent;
      position: absolute;
      bottom: -10px;
      left: 10px;
      z-index: 16;
      transition: border-color var(--transition-color-time) var(--transition-color-easing);
    }

    &:last-child:after {
      border-color: transparent;
    }

    &.active {
      background: $color--basic-blue;
      color: white;
      transition-delay: var(--item-delay);

      &:after {
        border-color: $color--basic-blue transparent transparent transparent;
        transition-delay: inherit;
      }

      &:last-child:after {
        border-color: transparent;
      }

      & > .steps__number-label {
        border-color: white;
        transition-delay: inherit;
      }
    }
  }

  .steps__number-label {
    border: $color--basic-dark-gray solid 1px;
    border-radius: 50%;
    width: 27px;
    height: 27px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 11px;
    position: relative;
    transition: border-color var(--transition-color-time) var(--transition-color-easing) 0s;

    &::before {
      counter-increment: works-title-list;
      content: counter(works-title-list);
    }
  }

  @media only screen and #{$screen-more-or-1024} {
    .how-it-works__header {
      margin-bottom: 25px;
      font-size: 25px;
      line-height: 30px;
    }

    .steps {
      display: grid;
      grid-template-columns: var(--steps-template-columns);
      grid-gap: 6px;
      font-size: 12px;
    }

    .steps__item {
      width: 100%;
      padding-right: 10px;

      &:not(:first-child) {
        padding-left: 33px;
      }

      &:not(:first-child):before {
        border-width: 34px 0 34px 17px;
        border-color: transparent transparent transparent $color--basic-black;
        top: 0;
        left: 0;
      }

      &:after {
        border-width: 34px 0 34px 17px;
        border-color: transparent transparent transparent $color--additional-gray;
        bottom: 0;
        left: 100%;
      }

      &.active:after {
        border-color: transparent transparent transparent $color--basic-blue;
      }
    }
  }

  @media only screen and (min-width: 1100px) {
    .steps {
      font-size: 13px;
      grid-gap: 10px;
    }

    .steps__item {
      padding-right: 15px;
    }
  }

  @media only screen and (min-width: 1300px) {
    .steps {
      grid-gap: 20px;
    }
  }
</style>
